/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { setSelectedReportTypeAction, setSelectedReportTaskAction, setSelectedReportCreatedAction, resetReportFiltersAction } from "./actions";
import { IReportFilterState } from "../types";
import dayjs from "dayjs";

const initialState: IReportFilterState = {
  selectedReportType: "",
  selectedReportTask: "",
  selectedReportCreated: dayjs(new Date()),
};
const reportFilterSlice = createSlice({
  name: "reportFilter",
  initialState,
  reducers: {
    setSelectedReportType: setSelectedReportTypeAction,
    setSelectedReportTask: setSelectedReportTaskAction,
    setSelectedReportCreated: setSelectedReportCreatedAction,
    resetReportFilters: resetReportFiltersAction,
  },
});

export const reportFilterReducer = reportFilterSlice.reducer;
export const { setSelectedReportType, setSelectedReportTask, setSelectedReportCreated, resetReportFilters } = reportFilterSlice.actions;
